
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisAtonPhysicalIec as ObiAisAtonPhysicalIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-aton-physical-iec.js';
 
 
 

 
 export const ObiAisAtonPhysicalIec = createComponent({
   react: React,
   tagName: 'obi-ais-aton-physical-iec',
   elementClass: ObiAisAtonPhysicalIecElement,
   events: {
     
   }
  });
 
 